<template>
  <b-container>
    <b-row>
      <h2>{{ $t("scheduler.schedulingForms") }}</h2>
      <success-fade-alert ref="alert" msg="Formulário exluido com sucesso" />
      <fade-alert-danger ref="danger" msg="Formulário não exluido" />
    </b-row>
    <br />
    <b-row>
      <b-table
        ref="MyForm"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage">
          <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th v-for="field in fields" :key="field.key">
                <div v-if="tableFilters[field.filterKey] != null">
                  <b-form-select
                    v-if="field.filterKey == 'formActive'"
                    :options="optionsBoolean"
                    v-model="tableFilters[field.filterKey]"
                  >
                  </b-form-select>
                  <b-form-input
                    v-else
                    v-model="tableFilters[field.filterKey]"
                    :placeholder="'Buscar por ' + field.label"
                  />
                </div>
              </b-th>
            </b-tr>
          </template>
          <template v-slot:cell(id)="data">
            <b-col class="buttons">
              <router-link :to="getUrlSchedulerForms(data.item)">
                  <b-button size="sm">{{ $t("scheduler.schedule") }}</b-button>
              </router-link>
            </b-col>
          </template>
          <template v-slot:cell(ativo)="data">
            {{ data.value ? "Sim" : "Não" }}
            <!-- <b-form-checkbox v-model="data.value" :value="true" :unchecked-value="false" disabled></b-form-checkbox> -->
          </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>
      <b-col>
        <label
          for="perPageSelect"
        >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{ tableRowCount }}</label>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-select
              v-model="tablePerPage"
              id="perPageSelect"
              size="sm"
              :options="tablePageOptions"
            />
          </b-col>
          <b-col>
            <label for="perPageSelect">Registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
  },
  data: function () {
    return {
      isBusy: false,
      fields: [
        {
          key: "id",
          sortable: false,
          label: "",
          tdClass: "checklist-own-table-col-buttons",
        },
        {
          key: "nome",
          filterKey: "formName",
          sortable: true
        },
      ],    
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFilters: {
        formName: "",
        formActive: true,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    getUrlSchedulerForms(form) {
        return `/checklist/scheduler/create/${form.id}`;
    },
    myProvider(ctx) {
      this.isBusy = true;
      return this.$apiChecklist
        .post(
          "/form/own/",
          {
            currentPage: ctx.currentPage,
            perPage: ctx.perPage,
            formActive: ctx.filter.formActive,
            formName: ctx.filter.formName,
          }
        )
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    activateForm(id) {
      this.$apiChecklist
        .get("/form/activate/" + id.toString())
        .then((response) => {
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.$refs.danger.msg =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    deleteForm(id) {
      console.log('delete')
      this.$apiChecklist
        .get("/form/delete/" + id.toString())
        .then((response) => {
          console.log(response.data);
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.$refs.danger.msg =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>

<style>
.checklist-own-table-col-buttons {
  width: 1%;
}

.checklist-own-table-col-buttons button {
  margin-right: 5px !important;
}

.checklist-own-table-col-ativo {
  width: 80px;
}
</style>

<style scoped>

.desktop-buttons {
  display: block;
}
@media (max-width: 576px) {
  .desktop-buttons {
    display: none;
  }
}

.list {
  margin-left: 24%;
}

.buttons {
  display: flex;
  justify-content: space-evenly;
}

.buttons b-button {
  width: 50%;
}
</style>
